import React from 'react';
import { iconsPath } from '../../../../../utils/imagePath';

export default function AssetVisibilityToggle({ visible, onToggle, className = '' }) {
  return (
    <button
      type="button"
      title={visible ? 'Hide asset' : 'Show asset'}
      aria-label={visible ? 'Hide asset' : 'Show asset'}
      className={`p-0.5 flex-shrink-0 ${className}`}
      onClick={(e) => {
        e.stopPropagation();
        onToggle?.();
      }}
    >
      <img
        src={iconsPath.eyeIcon}
        alt=""
        className={`w-[14px] h-[14px] object-contain transition-opacity ${
          visible ? 'opacity-100' : 'opacity-35'
        }`}
        style={visible ? undefined : { filter: 'grayscale(1)' }}
      />
    </button>
  );
}
